import {
  HttpRequestPost,
} from "./../../service/index";
import PromotionCodes from "../symbols/promotionCodes";

const referralCodesSymbolsAction = () => {
  return {
    type: PromotionCodes.GET_REFERRAL_CODES,
  };
};

const referralCodesClearSymbolsAction = () => {
  return {
    type: PromotionCodes.CLEAR_REFERRAL_CODES,
  };
};

const referralCodesSuccessAction = (data: any) => {
  return {
    type: PromotionCodes.GET_REFERRAL_CODES_SUCCESS,
    payload: data,
  };
};

const referralCodesFailureAction = (data: any) => {
  return {
    type: PromotionCodes.GET_REFERRAL_CODES_FAILURE,
    payload: data,
  };
};

export function clearReferralCodes() {
  return (dispatch: any) => {
    dispatch(referralCodesClearSymbolsAction());
  };
}

export interface IListReferralCodesRequestFilter {
  DiscountType: string[];
  UseType: string[];
  Status?: boolean;
}

type ListReferralCodesRequestModel = {
  Page: number;
  Size: number;
  Query: string;
  OrderBy: string;
  Filter: IListReferralCodesRequestFilter;
};

export function getReferralCodes(
  data: ListReferralCodesRequestModel = {
    Page: 1,
    Size: 15,
    Query: "",
    OrderBy: "Expires",
    Filter: {
      DiscountType: [],
      UseType: [],
    },
  }
) {
  return (dispatch: any) => {
    dispatch(referralCodesSymbolsAction());
    HttpRequestPost(
      "/portal/referral-code/list",
      dispatch,
      referralCodesSuccessAction,
      referralCodesFailureAction,
      true,
      data
    );
  };
}
